if (typeof trims !== 'undefined' && Array.isArray(trims)) {
    document.addEventListener('DOMContentLoaded', function() {
        const options = trims.map(trim => ({
            label: trim.name,
            value: trim.uri,
            key: trim.uri
        }));

        let preselected = [];

        // try to find a trim marked as default
        const defaultTrim = trims.find(t => t.default === "true");

        if (defaultTrim) {
            preselected = [defaultTrim.uri];
        } else if (trims.length > 0) {
            preselected = [trims[0].uri];
        }

        generateDropdown({
            containerId: 'interior-select',
            options,
            multiselect: false,
            name: 'interior',
            preselectedValues: preselected,
            disallowEmpty: true
        });
    });
}

/*function pdt360DegViewer(id, n, p, t, playable, autoPlay, draggable, mouseMove, buttons, keys, scroll, paint = null) {

    p = path;
    const initialSrc = updateQueryStringParameter(`${p}201`, 'paintId', paint);

    // console.log(id);
    // console.log(p);

    loaderNone(id);
    var i = 201,
        j = 0,
        move = [],
        mainDiv = document.querySelector(`#${id}`);
    mainDiv.className = 'viewer';
    mainDiv.innerHTML = '';
    mainDiv.innerHTML += `<img class="${id} ${playable ? 'playable ' : ''}${autoPlay ? 'autoPlay ' : ''}${draggable ? 'draggable ' : ''}${mouseMove ? 'mouseMove ' : ''}${buttons ? 'buttons ' : ''}${keys ? 'keys ' : ''}${scroll ? 'scrollath ' : ''}" draggable="false" src='${initialSrc}'>`;
    mainDiv.innerHTML +=
        '<div class="loader"><div class="three-bounce"><div class="one"></div><div class="two"></div><div class="three"></div></div></div>'

    for (var k = 201; k <= n; k++) {
        // console.log(p);
        const paintedSrc = updateQueryStringParameter(`${path}${k}`, 'paintId', paint);
        document.getElementById('dummy').innerHTML += `<img src='${paintedSrc}'>`;
    }

    var img = document.querySelector(`#${id} .${id}`);
    // console.log(img);

    if (!playable && !autoPlay) {
        var touch = false;
        (window.matchMedia("screen and (max-width: 992px)").matches) ? touchFun(): nonTouch();

        //For Touch Devices
        window.addEventListener('touchstart', function() {
            touchFun();
        });

        function touchFun() {
            touch = true;
            img.removeAttribute('draggable');
            img.addEventListener('touchmove', function(e) {
                // console.log(e);
                logic(this, e);
                // console.log(11);
            });
            img.addEventListener('touchend', function(e) {
                move = [];
            });
        }
        //For Non-Touch Devices
        function nonTouch() {
            touch = false;
            if (draggable) {
                var drag = false;
                img.addEventListener('mousedown', function(e) {
                    drag = true;
                    logic(this, e);
                    // console.log(22);
                });
                img.addEventListener('mouseup', function(e) {
                    drag = false;
                    move = [];
                });
                mouseEvent();
            }

            if (mouseMove) {
                drag = true;
                mouseEvent();
            }

            function mouseEvent() {
                img.addEventListener('mousemove', function(e) {

                    (drag) ? logic(this, e): null;
                    // console.log(33);
                });
                img.addEventListener('mouseleave', function() {
                    move = [];
                });
            }
            if (scroll) {
                img.addEventListener('wheel', function(e) {
                    e.preventDefault();
                    (e.wheelDelta / 120 > 0) ? nxt(this): prev(this);
                    // console.log(1);
                });
            }
            if (keys) {
                img.setAttribute('tabindex', '0');
                img.onkeydown = function(e) {
                    e.preventDefault();
                    if (e.keyCode == 37 || e.keyCode == 38)
                        prev(img);
                    else if (e.keyCode == 39 || e.keyCode == 40)
                        nxt(img);
                    // console.log(2);
                };
            }
        }

        function logic(el, e) {

            j++;
            var x = touch ? e.touches[0].clientX : e.clientX;
            var coord = (x - img.offsetLeft);
            move.push(coord);

            var l = move.length,
                oldMove = move[l - 2],
                newMove = move[l - 1];
            var thresh = touch ? true : !(j % 3);
            if (thresh) {
                if (newMove > oldMove) {

                    nxt(el);
                    // console.log(3);
                } else if (newMove < oldMove) {
                    prev(el);
                }
            }
        }
        if (buttons) {
            var btnsDiv = document.createElement('div');
            btnsDiv.className = 'btnDiv navDiv';

            var leftNavBtn = document.createElement('button');
            leftNavBtn.className = 'play leftNav';
            leftNavBtn.setAttribute('title', 'left navigation');
            btnsDiv.appendChild(leftNavBtn);
            leftNavBtn.addEventListener('click', function() {
                prev(img);
            });

            var rightNavBtn = document.createElement('button');
            rightNavBtn.className = 'play rightNav';
            rightNavBtn.setAttribute('title', 'right navigation');
            btnsDiv.appendChild(rightNavBtn);
            rightNavBtn.addEventListener('click', function() {
                nxt(img);
                // console.log(4);
            });
            img.parentNode.appendChild(btnsDiv);
        }
    } else {
        var interval, playing = false,
            pause = false,
            left = false,
            right = false,
            speed = 50;

        if (playable) {
            var btnDiv = document.createElement('div');
            btnDiv.className = 'btnDiv';

            var playBtn = document.createElement('button');
            playBtn.className = 'play';
            playBtn.setAttribute('title', 'play');
            btnDiv.appendChild(playBtn);
            playBtn.addEventListener('click', function() {
                playing = true;
                pause = false;
                play();
            });

            var pauseBtn = document.createElement('button');
            pauseBtn.className = 'pause';
            pauseBtn.setAttribute('title', 'pause');
            btnDiv.appendChild(pauseBtn);
            pauseBtn.addEventListener('click', function() {
                pause = true;
            });

            var stopBtn = document.createElement('button');
            stopBtn.className = 'stop';
            stopBtn.setAttribute('title', 'stop');
            btnDiv.appendChild(stopBtn);

            stopBtn.addEventListener('click', function() {
                pause = true;
                speed = 50;
                right = true;
                left = false;
                this.parentNode.parentNode.querySelector('imgath').src = `${p}201`;
            });

            var leftBtn = document.createElement('button');
            leftBtn.className = 'left';
            leftBtn.setAttribute('title', 'play direction-left');
            btnDiv.appendChild(leftBtn);
            leftBtn.addEventListener('click', function() {
                right = false;
                left = true;
                if (playing)
                    play();
            });

            var rightBtn = document.createElement('button');
            rightBtn.className = 'right';
            rightBtn.setAttribute('title', 'play direction-right');
            btnDiv.appendChild(rightBtn);
            rightBtn.addEventListener('click', function() {
                left = false;
                right = true;
                if (playing)
                    play();
            });

            var speedBtn = document.createElement('button');
            speedBtn.className = 'plus';
            speedBtn.setAttribute('title', 'increase play speed');
            btnDiv.appendChild(speedBtn);
            speedBtn.addEventListener('click', function() {
                if (playing)
                    timer(speed > 10 ? speed -= 10 : speed);
            });

            var slowBtn = document.createElement('button');
            slowBtn.className = 'minus';
            slowBtn.setAttribute('title', 'decrease play speed');
            btnDiv.appendChild(slowBtn);
            slowBtn.addEventListener('click', function() {
                if (playing)
                    timer(speed < 100 ? speed += 10 : speed);
            });

            mainDiv.prepend(btnDiv);
        }

        function play() {
            timer(speed);
        }

        function timer(t) {
            clearInterval(interval);
            interval = setInterval(function() {
                if (!pause) {
                    if (left) {
                        prev(img);
                    } else if (right) {
                        nxt(img);
                        // console.log(5);
                    } else {
                        nxt(img);
                        // console.log(6);
                    }
                }
            }, t);
        }
    }

    function prev(e) {
        if (i <= 201) {
            i = n;
        } else {
            i--;
        }
        // console.log(pickedColour);
        e.src = updateQueryStringParameter(`${path}${i}`, 'paintId', pickedColour);
    }

    function nxt(e) {
        if (i >= n) {
            i = 201;
        } else {
            i++;
        }
        // console.log(pickedColour);
        e.src = updateQueryStringParameter(`${path}${i}`, 'paintId', pickedColour);
    }

    function loaderNone(id) {
        window.addEventListener('load', function() {
            document.querySelector(`#${id} .loader`).style.display = 'none';
            if (autoPlay) {
                pause = false;
                play();
            }
        });
    }


    window.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            document.querySelector('.deal-gallery').classList.remove('full-screen');
            document.querySelector('.deal-gallery .gallery-options a.full-screen svg:first-child').classList.remove('hidden');
            document.querySelector('.deal-gallery .gallery-options a.full-screen svg:last-child').classList.add('hidden');

            document.querySelector('.deal-gallery-360').classList.remove('full-screen');
            document.querySelector('.deal-gallery-360 .gallery-options a.full-screen svg:first-child').classList.remove('hidden');
            document.querySelector('.deal-gallery-360 .gallery-options a.full-screen svg:last-child').classList.add('hidden');
        }
    })


}*/
if (typeof paints !== 'undefined' && Array.isArray(paints)) {
    document.addEventListener('DOMContentLoaded', function() {


        var addMultipleListeners = (el, types, listener, options, useCapture) => {
            types.forEach(type =>
                el.addEventListener(type, listener, options, useCapture)
            );
        };

        if (document.querySelector('a.load-paints') && document.querySelector('.derivative-colour-picker')) {
            document.querySelector('.load-paints').addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelectorAll('.derivative-colour-picker').forEach(div => {
                    div.classList.toggle('hidden');
                });
            })
        }

        if (document.querySelector('a.close-paints') && document.querySelector('.derivative-colour-picker')) {
            document.querySelector('.close-paints').addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelectorAll('.derivative-colour-picker').forEach(div => {
                    div.classList.toggle('hidden');
                });
            })
        }

        // Paint Change
        if (document.querySelector('input[data-paint-id]')) {
            document.querySelectorAll('input[data-paint-id]').forEach(ele => {
                // ele.addEventListener('click', function(e){ 
                // addMultipleListeners(ele, ['click', 'change'], (e) => {


                //     // console.log(pickedColour);
                //     if (pickedColour != null) {
                //         paint = pickedColour;

                //         document.querySelectorAll('img[src*="imagin.studio"]').forEach(ele => {
                //             let url = ele.getAttribute('src');
                //             url = updateQueryStringParameter(url, 'paintId', paint);
                //             ele.setAttribute('src', url);
                //         });

                //         document.querySelectorAll('a[data-img*="imagin.studio"]').forEach(ele => {
                //             let img = ele.getAttribute('data-img');
                //             img = updateQueryStringParameter(img, 'paintId', paint);
                //             ele.setAttribute('data-img', img);
                //         });

                //         let new_path = updateQueryStringParameter(path, 'paintId', paint);
                //         path = new_path;


                //     }


                //     (document.querySelector('.colour-picker > span.active')) ? document.querySelector('.colour-picker > span.active').classList.remove('active'): null;

                //     document.querySelector('.colour-picker > span[data-paint-uri=' + e.target.dataset.paintUri + ']').classList.add('active');


                // })
            });
        }

        // Color Picker
        document.querySelectorAll('.colour-picker > span').forEach(value => {
            value.addEventListener('click', (e) => {
                updateOptionMonthly('.colour-tooltip');

                (document.querySelector('.colour-picker > span.active')) ? document.querySelector('.colour-picker > span.active').classList.remove('active'): null;

                const name = e.target.dataset.name;
                const pch = e.target.dataset.monthlyVat;
                const bch = e.target.dataset.monthly;

                const price = document.querySelector('#quote-form [name="type"]').value === 'Personal' ? pch : bch;
                const spanEl = document.querySelector('.colour-picker-text > span');

                if (spanEl) {
                    spanEl.innerHTML = `${name} <span class="text-red">+ £${parseFloat(price).toFixed(2)}  per month</span>`;
                } else {
                    document.querySelector('.colour-picker-text').innerHTML =
                        `View available colours: <span>${name} <span class="text-red">£${parseFloat(price).toFixed(2)}</span></span>`;
                }

                e.target.classList.add('active');
                document.querySelectorAll('img[src*="imagin.studio"]').forEach(ele => {
                    let url = ele.getAttribute('src');
                    url = replacePaintId(url, e.target.dataset.paintId);
                    ele.setAttribute('src', url);
                });
                document.querySelectorAll('a[data-img*="imagin.studio"]').forEach(ele => {
                    let img = ele.getAttribute('data-img');
                    img = replacePaintId(img, e.target.dataset.paintId);
                    ele.setAttribute('data-img', img);
                });
            });
        })

        document.querySelectorAll('.colour-picker > span').forEach(value => {
            value.addEventListener('click', (e) => {

                calculatePaintMonthly(paints);

                // document.querySelector('.gallery-top .loading').classList.remove('hidden');
                // document.querySelector('.gallery-top .swiper-wrapper').style.opacity = '0.5';

                // setTimeout(function(){
                //   document.querySelector('.gallery-top .loading').classList.add('hidden');
                //   // document.querySelector('.gallery-top .swiper-wrapper').style.opacity = '1';
                // }, 2000);

                pickedColour = e.target.dataset.paintId;

                document.querySelector('input[name="options"]').value = e.target.dataset.name;

                document.querySelector('input[name="options_total"]').value =
                document.querySelector('#quote-form [name="type"]').value == 'personal' ? e.target.dataset["monthlyVat"] : e.target.dataset["monthly"];

                    // console.log(document.querySelector('input[name="options_total"]').value);

                if (document.getElementById('colour-select') && !document.getElementById('colour-select').classList.contains('open')) {
                    // console.log(paints);
                    colourDropdownInit();
                }

                updateOptionMonthly('.colour-tooltip');
                loadPrice();


                (document.querySelector('.colour-picker > span.active')) ? document.querySelector('.colour-picker > span.active').classList.remove('active'): null;

                e.target.classList.add('active');
            });
        });

        // });


        if (document.querySelector('a.load-360')) {
            document.querySelector('.load-360').addEventListener('click', function(e) {

                e.preventDefault();
                document.querySelector('.deal-gallery-360').classList.toggle('full-screen');
                // pdt360DegViewer('car-360', 231, path, '', false, false, true, false, false, false, false);
                if (document.querySelector('.deal-gallery-360').classList.contains('full-screen') || document.querySelector('.deal-gallery').classList.contains('full-screen')) {
                    document.body.classList.add('fullscreen-gallery-active');
                } else {
                    document.body.classList.remove('fullscreen-gallery-active');
                }
            })
        }


        if (window.location.hash == "#360") {
            document.querySelector('a.load-360').click();
        }

    });


}

function replacePaintId(url, paintId) {
    url = url.replace(/([?&])paintId=[^&]+(&)?/, (match, p1, p2) => p2 ? p1 : '');
    url = url.replace(/[?&]$/, '');
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}paintId=${paintId}`;
}

function colourDropdownInit() {
    if (!document.querySelector('.colour-picker > span.active[data-paint-id]')) return;
    const pickedColour = document.querySelector('.colour-picker > span.active[data-paint-id]').dataset.paintId;
    const options = paints.map(paint => {
        // console.log(paint.monthly);

        const price = document.querySelector('#quote-form [name="type"]').value == 'personal' ? paint.monthlyVat : paint.monthly;

        return {
            label: `${paint.name} (£${parseFloat(price).toFixed(2)})`,
            value: paint.id,
            image: paint.uri
        };
    });

    generateDropdown({
        containerId: 'colour-select',
        options,
        multiselect: false,
        name: 'colour',
        preselectedValues: [pickedColour]
    });
}

document.addEventListener('DOMContentLoaded', function() {
    if(typeof updateOptionMonthly !== 'function') return;

    updateOptionMonthly('.colour-tooltip');

    const activeTarget = document.querySelector('.colour-picker > span.active');

    if (!activeTarget) return;

    const { name, monthlyVat: pch, monthly: bch } = activeTarget.dataset;

    const type = document.querySelector('#quote-form [name="type"]')?.value;
    const price = type === 'personal' ? pch : bch;

    const spanEl = document.querySelector('.colour-picker-text > span');

    if (spanEl && price) {
        spanEl.innerHTML = `
            ${name}
            <span class="text-red">
                + £${parseFloat(price).toFixed(2)} per month
            </span>
        `;
    }
 

    const freeColourOption = document.querySelector('.derivative-colour-picker .colour-picker span[data-price="0"]');
    const firstAvailableColourOption = document.querySelector('.derivative-colour-picker .colour-picker span');

    if (freeColourOption) {
        // freeColourOption.click();
    } else if (firstAvailableColourOption) {
        // firstAvailableColourOption.click();
    }
});